import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

function Shell({ title, text, children }) {
  return (
    <div className="min-h-screen bg-forest flex items-center justify-center p-6" data-testid="admin-auth-page">
      <div className="bg-ecru w-full max-w-md rounded-3xl p-8 sm:p-10">
        <p className="eyebrow">Le Chalet Badouille Izoard</p>
        <h1 className="font-serif text-3xl text-forest mt-2">{title}</h1>
        {text && <p className="text-sm text-charcoal/60 mt-2">{text}</p>}
        <div className="mt-8">{children}</div>
        <p className="text-center mt-8 text-xs"><Link to="/" className="text-charcoal/50 hover:text-forest">← Retour au site</Link></p>
      </div>
    </div>
  );
}

export function Login() {
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await api.post("/auth/login", f); localStorage.setItem("admin_token", r.data.token); nav(r.data.user.must_change_password ? "/admin/compte" : "/admin"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Espace administrateur" text="Connectez-vous pour gérer le site.">
      <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
        <div><label className="label" htmlFor="l-email">Email</label><input id="l-email" type="email" className="input" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="login-email-input" autoComplete="username" /></div>
        <div><label className="label" htmlFor="l-pw">Mot de passe</label><input id="l-pw" type="password" className="input" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password-input" autoComplete="current-password" /></div>
        <button type="submit" disabled={busy} className="btn-primary w-full py-4" data-testid="login-submit-btn">{busy ? "Connexion…" : "Se connecter"}</button>
        <p className="text-center text-xs"><Link to="/admin/mot-de-passe-oublie" className="text-charcoal/60 hover:text-forest underline-offset-4 hover:underline" data-testid="forgot-password-link">Mot de passe oublié ?</Link></p>
      </form>
    </Shell>
  );
}

export function Forgot() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => { e.preventDefault(); setBusy(true); try { const r = await api.post("/auth/forgot-password", { email }); setMsg(r.data.message); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); } };
  return (
    <Shell title="Mot de passe oublié" text="Nous vous enverrons un lien sécurisé pour définir un nouveau mot de passe.">
      {msg ? <p className="text-sm text-forest bg-sage-100 rounded-xl p-4" data-testid="forgot-success">{msg}</p> : (
        <form onSubmit={submit} className="space-y-4">
          <div><label className="label" htmlFor="f-email">Email</label><input id="f-email" type="email" className="input" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></div>
          <button type="submit" disabled={busy} className="btn-primary w-full py-4" data-testid="forgot-submit-btn">{busy ? "Envoi…" : "Envoyer le lien"}</button>
        </form>)}
      <p className="text-center text-xs mt-4"><Link to="/admin/login" className="text-charcoal/60 hover:text-forest">Retour à la connexion</Link></p>
    </Shell>
  );
}

export function Reset() {
  const { token } = useParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault(); if (pw !== pw2) return toast.error("Les mots de passe ne correspondent pas");
    setBusy(true); try { await api.post("/auth/reset-password", { token, password: pw }); toast.success("Mot de passe mis à jour"); nav("/admin/login"); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Nouveau mot de passe" text="10 caractères minimum.">
      <form onSubmit={submit} className="space-y-4">
        <div><label className="label" htmlFor="r-pw">Nouveau mot de passe</label><input id="r-pw" type="password" className="input" required minLength={10} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" autoComplete="new-password" /></div>
        <div><label className="label" htmlFor="r-pw2">Confirmation</label><input id="r-pw2" type="password" className="input" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" autoComplete="new-password" /></div>
        <button type="submit" disabled={busy} className="btn-primary w-full py-4" data-testid="reset-submit-btn">{busy ? "Enregistrement…" : "Définir le mot de passe"}</button>
      </form>
    </Shell>
  );
}
